(function($) {
	$('.block-text-tabs').each(function() {
		var $container = $(this);

		var $tabs = $container.find('.tab');
		var $tabLink = $container.find('.tab').find('a');
		var $content = $container.find('.tab-box');

		$tabLink.click(function(e) {
			e.preventDefault();
			e.stopPropagation();

			$tabs.removeClass('active');
			$(this).closest('li').addClass('active');

			$content.removeClass('active');
			var href = $(this).attr('href');
			href.substr(1);

			$(href).addClass('active');
		});
	});
	
	var $contentContainers = $('.tab-content-container');
	var resizeBlock;
	(resizeBlock = function() {
		$contentContainers.each(function() {
			var $c = $(this);
			$c.css('height', '');

			var maxHeight = 0;
			$c.find('.tab-box').each(function(i, elm) {
				maxHeight = Math.max(maxHeight, $(elm).outerHeight());
			});

			$c.css('height', maxHeight);
		});
	})();

	$(window).on('resize orientationchange', function() {
		resizeBlock();
	});
})(jQuery);